import { memo } from "react";
import {
  Grid,
  Button,
  IconButton,
  Typography,
  Box,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export interface IFreeAlternative {
  id: string | null;
  label: string;
  nrOption: number;
  integrationId?: string;
}

interface QuestionAlternativesFreeProps {
  value: IFreeAlternative[];
  onChange: (alts: IFreeAlternative[]) => void;
}

export const QuestionAlternativesFree = memo(
  ({ value, onChange }: QuestionAlternativesFreeProps) => {
    const handleAdd = () => {
      onChange([
        ...value,
        { id: null, label: "", nrOption: value.length + 1, integrationId: "" },
      ]);
    };

    const handleRemove = (index: number) => {
      const updated = value
        .filter((_, i) => i !== index)
        .map((alt, i) => ({ ...alt, nrOption: i + 1 }));
      onChange(updated);
    };

    const handleChange = (
      index: number,
      field: keyof IFreeAlternative,
      val: string | number,
    ) => {
      const updated = value.map((alt, i) =>
        i === index ? { ...alt, [field]: val } : alt,
      );
      onChange(updated);
    };

    return (
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          Alternativas
        </Typography>

        {value.map((alt, index) => (
          <Grid container spacing={1} alignItems="center" key={index} mb={1}>
            <Grid item xs={2} sm={2}>
              <TextField
                label="Nº Opção"
                type="number"
                size="small"
                fullWidth
                value={alt.nrOption}
                onChange={(e) =>
                  handleChange(index, "nrOption", Number(e.target.value))
                }
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <TextField
                label="Label"
                size="small"
                fullWidth
                value={alt.label}
                onChange={(e) => handleChange(index, "label", e.target.value)}
              />
            </Grid>
            <Grid item xs={4} sm={5}>
              <TextField
                label="Valor de Referência"
                size="small"
                fullWidth
                value={alt.integrationId ?? ""}
                onChange={(e) =>
                  handleChange(index, "integrationId", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={2} sm={1}>
              <IconButton
                color="error"
                size="small"
                onClick={() => handleRemove(index)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
        ))}

        <Button
          variant="outlined"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleAdd}
          sx={{ mt: 1 }}
        >
          Adicionar alternativa
        </Button>
      </Box>
    );
  },
);
